import type { AdditionalSettings, ContentImage } from "@site-types/site"

function localImage(
  url: string,
  title: string,
  dimensions?: { width: number; height: number }
): ContentImage {
  return {
    asset: {
      url,
      title,
      ...dimensions,
    },
  }
}

const commonSettings = {
  title: "Local site settings",
  homePageGamersImage: localImage("/images/home/gamers.webp", "PLAYBRAIN gamers", {
    width: 1800,
    height: 1800,
  }),
  homePageBrandImage: localImage("/images/home/playbrain-symbol.svg", "PLAYBRAIN symbol", {
    width: 300,
    height: 300,
  }),
  homePageFutarokuLogo: localImage("/images/futaroku-logo.svg", "Futaroku"),
  homePageTaiyoroLogo: localImage("/images/taiyoro-logo.svg", "Taiyoro"),
  homePageTaiyoroBackground: localImage("/images/home/taiyoro-background.webp", "Taiyoro background", {
    width: 1440,
    height: 810,
  }),
  homePagePlaydataLogo: localImage("/images/playdata-logo.svg", "Playdata"),
  homePagePlaydataBackground: localImage("/images/home/playdata-background.webp", "Playdata background", {
    width: 1024,
    height: 625,
  }),
  homePageFluxLogo: localImage("/images/flux-logo.svg", "Flux"),
  workPageVideoUrl:
    "https://www.youtube.com/embed/8ko7vCgKOcI?si=KJj-OEJSELuGcaKf?autoplay=1&loop=1&mute=1&origin=https://playbrain.com",
} satisfies Omit<AdditionalSettings, "language" | "workPageVideoTags">

export const localAdditionalSettings = [
  {
    ...commonSettings,
    language: "en",
    workPageVideoTags: [
      "Esports Tournament and League Operations",
      "Content Broadcast",
      "Online Event Production",
      "Offline Event Production",
      "Esports business consulting",
    ],
  },
  {
    ...commonSettings,
    language: "ja",
    workPageVideoTags: [
      "eスポーツ大会およびリーグの運営",
      "ライブ配信",
      "オンラインイベント制作・運営",
      "オフラインイベント制作・運営",
      "eスポーツビジネスのコンサルティング",
    ],
  },
] satisfies AdditionalSettings[]
